define(['jquery', 'core/ajax', 'core/str', 'core/url', 'sweetalert2', 'local_custom_auth/commonreg', 'select2-js'
],
function($, ajax, str, moodleUrl, Swal, commonReg, select2) {
    var index = {
        dom: {
            main: null
        },
        variable: {
            dataTableReference: null,
            imageExtensions: ['image/jpeg', 'image/png', 'image/jpg'],
            documentExtensions: ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'],
            checkEmailPattern: /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,

        },
        langs: {
            enterCompanyName: null,
            enterEmail: null,
            enterValidEmail: null,
            enterMobileNumber: null,
            enterValidMobileNumber: null,
            enterValidPanNumber: null,
            enterValidTanNumber: null,
            otpValid: null,
            enterValidGstnNumber: null,
            enterSpocName: null,
            enterValidSpocEmail: null,
            selectSector: null,
            country: null,
            enterLane1: null,
            enterLane2: null,
            selectState: null,
            selectCity: null,
            enterValidZipcode: null,
            enterAnnualDemandForHiring: null,
            uploadValidImage: null,
            uploadValidCertificate: null,
            uploadAddressProof: null,
            pleaseAcceptTermAndCon: null,
            emailAlreadyInUse: null,
            processing: null,
            pleaseWait: null,
            selectTypeofIndustry: null,
            oops: null,
            thanksForSubmittingTheForm: null,
            submitButton: null,

        },
        action: {
            getString: function() {
                str.get_strings([
                    {key: 'entercompanyname', component: 'local_custom_auth'},
                    {key: 'enteremail', component: 'local_custom_auth'},
                    {key: 'entervalidemail', component: 'local_custom_auth'},
                    {key: 'entermobilenumber', component: 'local_custom_auth'},
                    {key: 'entervalidmobilenumber', component: 'local_custom_auth'},
                    {key: 'entervalidpannumber', component: 'local_custom_auth'},
                    {key: 'entervalidtannumber', component: 'local_custom_auth'},
                    {key: 'otpvalid', component: 'local_custom_auth'},
                    {key: 'entervalidgstnnumber', component: 'local_custom_auth'},
                    {key: 'enterspocname', component: 'local_custom_auth'},
                    {key: 'entervalidspocemail', component: 'local_custom_auth'},
                    {key: 'selectsector', component: 'local_custom_auth'},
                    {key: 'country', component: 'local_custom_auth'},
                    {key: 'enterlane1', component: 'local_custom_auth'},
                    {key: 'enterlane2', component: 'local_custom_auth'},
                    {key: 'selectstate', component: 'local_custom_auth'},
                    {key: 'selectcity', component: 'local_custom_auth'},
                    {key: 'entervalidzipcode', component: 'local_custom_auth'},
                    {key: 'enterannualdemandforhiring', component: 'local_custom_auth'},
                    {key: 'uploadvalidimage', component: 'local_custom_auth'},
                    {key: 'uploadvalidcertificate', component: 'local_custom_auth'},
                    {key: 'uploadaddressproof', component: 'local_custom_auth'},
                    {key: 'pleaseaccepttermandcon', component: 'local_custom_auth'},
                    {key: 'emailalreadyinuse', component: 'local_custom_auth'},
                    {key: 'processing', component: 'local_custom_auth'},
                    {key: 'pleasewait', component: 'local_custom_auth'},
                    {key: 'selecttypeofindustry', component: 'local_custom_auth'},
                    {key: 'oops', component: 'local_custom_auth'},
                    {key: 'thanksforsubmittingtheform', component: 'local_custom_auth'},
                    {key: 'submitbutton', component: 'local_custom_auth'},

                ]).then(function(s) {
                    index.langs.enterCompanyName = s[0];
                    index.langs.enterEmail = s[1];
                    index.langs.enterValidEmail = s[2];
                    index.langs.enterMobileNumber = s[3];
                    index.langs.enterValidMobileNumber = s[4];
                    index.langs.enterValidPanNumber = s[5];
                    index.langs.enterValidTanNumber = s[6];
                    index.langs.otpValid = s[7];
                    index.langs.enterValidGstnNumber = s[8];
                    index.langs.enterSpocName = s[9];
                    index.langs.enterValidSpocEmail = s[10];
                    index.langs.selectSector = s[11];
                    index.langs.country = s[12];
                    index.langs.enterLane1 = s[13];
                    index.langs.enterLane2 = s[14];
                    index.langs.selectState = s[15];
                    index.langs.selectCity = s[16];
                    index.langs.enterValidZipcode = s[17];
                    index.langs.enterAnnualDemandForHiring = s[18];
                    index.langs.uploadValidImage = s[19];
                    index.langs.uploadValidCertificate = s[20];
                    index.langs.uploadAddressProof = s[21];
                    index.langs.pleaseAcceptTermAndCon = s[22];
                    index.langs.emailAlreadyInUse = s[23];
                    index.langs.processing = s[24];
                    index.langs.pleaseWait = s[25];
                    index.langs.selectTypeofIndustry = s[26];
                    index.langs.oops = s[27];
                    index.langs.thanksForSubmittingTheForm = s[28];
                    index.langs.submitButton = s[29];
                    index.init();
                }).fail(function(e) {});
            },
            createIndustryAjax: function() {
                $('#btn-save-changes').html(index.langs.processing).attr('disabled', true);
                var promises = ajax.call([{
                    methodname: 'local_custom_auth_get_industry_registration_details',
                    args: {
                        companyname: index.dom.firstName.val().trim(),
                        spocemail: index.dom.spocEmail.val().trim(),
                        phone: index.dom.phone.val().trim(),
                        validateotp: index.dom.validateOtp.val().trim(),
                        pan: index.dom.pan.val().trim(),
                        tan: index.dom.tan.val().trim(),
                        gstin: index.dom.gstin.val().trim(),
                        addressline2: index.dom.addressLine2.val().trim(),
                        addressline1: index.dom.addressLine1.val().trim(),
                        sector: index.dom.jobSector.val(),
                        country: index.dom.country.val(),
                        state: index.dom.state.val(),
                        city: index.dom.city.val(),
                        zipcode: index.dom.zipCode.val().trim(),
                        spocfullname: index.dom.spocFullname.val().trim(),
                        spocemail1: index.dom.spocEmail1.val().trim(),
                        annualdemandforhiring: index.dom.annualDemandForHiring.val().trim(),
                    }
                }]);
                promises[0].done(function(result) {
                if (result.status == true) {
                        index.dom.industryRegistrationForm.submit();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: index.langs.thanksForSubmittingTheForm,
                            showConfirmButton: false,
                            timer: 3000
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 1500);
                    } else {
                        Swal.fire({
                            position: 'center',
                            title: index.langs.oops,
                            text: result.message,
                            imageUrl: './pix/error.png',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        $('#btn-save-changes').html(index.langs.submitButton).attr('disabled', false);
                    }
                }).fail(function() {
                });
            },
            resetValidationError: function() {
                index.dom.firstNameRequired.html('');
                index.dom.requiredMobile.html('');
                index.dom.mobileValidateError.html('');
                index.dom.otpValidateRequired.html('');
                index.dom.jobSectorRequired.html('');
                index.dom.panRequired.html('');
                index.dom.tanRequired.html('');
                index.dom.gstinRequired.html('');
                index.dom.countryRequired.html('');
                index.dom.spocEmail1Required.html('');
                index.dom.spocFullNameRequired.html('');
                index.dom.spocEmailRequired.html('');
                index.dom.spocMobileValidateError.html('');
                index.dom.addressLine1Required.html('');
                index.dom.addressLine2Required.html('');
                index.dom.stateRequired.html('');
                index.dom.cityRequired.html('');
                index.dom.zipCodeRequired.html('');
                index.dom.annualeDmandforhiringRequired.html('');
                index.dom.logoFileRequired.html('');
                index.dom.certificateOfIncorporationRequired.html('');
                index.dom.addressProofRequired.html('');
            },
            fieldValidationError: function() {
                index.action.resetValidationError();
                if (index.dom.firstName.val().trim() == '') {
                    index.dom.firstNameRequired.html(index.langs.enterCompanyName).css({color: 'red'});
                    return false;
                } else if (index.dom.spocEmail.val().trim() == '') {
                    index.dom.spocEmailRequired.html(index.langs.enterEmail).css({color: 'red'});
                    return false;
                } else if (!index.variable.checkEmailPattern.test(index.dom.spocEmail.val().trim())) {
                    index.dom.spocEmail1Required.html(index.langs.enterValidEmail).css({color: 'red'});
                    return false;
                } else if (index.dom.spocFullname.val().trim() == '') {
                    index.dom.spocFullNameRequired.html(index.langs.enterSpocName).css({color: 'red'});
                    return false;
                } else if (index.dom.spocEmail1.val().trim() == '') {
                    index.dom.spocEmail1Required.html(index.langs.enterValidSpocEmail).css({color: 'red'});
                    return false;
                } else if (index.dom.phone.val().trim() == '') {
                    index.dom.requiredMobile.html(index.langs.enterMobileNumber).css({color: 'red'});
                    return false;
                } else if ($.isNumeric(index.dom.phone.val().trim()) && index.dom.phone.val().trim().length != 10) {
                    index.dom.mobileValidateError.html(index.langs.enterValidMobileNumber).css({color: 'red'});
                    return false;
                } else {
                    return true;
                }
            },
            initStateSelect2: function() {
                index.dom.state.select2({
                    placeholder: index.langs.selectState,
                    allowClear: true,
                    ajax: {
                        delay: 1000,
                        data: function(params) {
                            var query = {
                                search: params.term,
                                page: params.page || 1
                            };
                            // Query parameters will be ?search=[term]&page=[page]
                            return query;
                        },
                        transport: function(params, success, failure) {
                            params.id = index.dom.country.val();
                            params.requesttype = true;
                            var promises = ajax.call([{
                                args: params,
                                methodname: 'local_custom_auth_get_select2_state'
                            }]);
                            promises[0].done(success).fail(failure);
                        },
                        // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                    },
                    dropdownParent: index.dom.state.parent('div')
                });
            },
            initCitySelect2: function() {
                index.dom.city.select2({
                    placeholder:  index.langs.selectCity,
                    allowClear: true,
                    ajax: {
                        delay: 1000,
                        data: function(params) {
                            var query = {
                                search: params.term,
                                page: params.page || 1
                            };
                            // Query parameters will be ?search=[term]&page=[page]
                            return query;
                        },
                        transport: function(params, success, failure) {
                            params.id = index.dom.state.val();
                            params.requesttype = true;
                            var promises = ajax.call([{
                                args: params,
                                methodname: 'local_custom_auth_get_select2_city'
                            }]);
                            promises[0].done(success).fail(failure);
                        },
                        // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                    },
                    dropdownParent: index.dom.city.parent('div')
                });
            },
        },

        init: function() {
            index.dom.main = $(document).find('#industryModal');
            index.dom.firstNameRequired = index.dom.main.find('#firstnameRequired');
            index.dom.requiredMobile = index.dom.main.find('#requiredmobile');
            index.dom.mobileValidateError = index.dom.main.find('#mobilevalidateerror');
            index.dom.otpValidateRequired = index.dom.main.find('#otpvalidateRequired');
            index.dom.jobSectorRequired = index.dom.main.find('#jobsectorRequired');
            index.dom.panRequired = index.dom.main.find('#panRequired');
            index.dom.tanRequired = index.dom.main.find('#tanRequired');
            index.dom.gstinRequired = index.dom.main.find('#gstinRequired');
            index.dom.countryRequired = index.dom.main.find('#countryRequired');
            index.dom.spocEmail1Required = index.dom.main.find('#spocemail1Required');
            index.dom.spocFullNameRequired = index.dom.main.find('#spocfullnameRequired');
            index.dom.spocEmailRequired = index.dom.main.find('#spocemailRequired');
            index.dom.spocMobileValidateError = index.dom.main.find('#spocmobilevalidateerror');
            index.dom.addressLine1Required = index.dom.main.find('#addressline1Required');
            index.dom.addressLine2Required = index.dom.main.find('#addressline2Required');
            index.dom.stateRequired = index.dom.main.find('#stateRequired');
            index.dom.cityRequired = index.dom.main.find('#cityRequired');
            index.dom.zipCodeRequired = index.dom.main.find('#zipcodeRequired');
            index.dom.annualeDmandforhiringRequired = index.dom.main.find('#annualdemandforhiringRequired');
            index.dom.logoFileRequired = index.dom.main.find('#logofileRequired');
            index.dom.certificateOfIncorporationRequired = index.dom.main.find('#certificateofincorporationRequired');
            index.dom.addressProofRequired = index.dom.main.find('#addressproofRequired');


            index.dom.firstName = index.dom.main.find('#firstname');
            index.dom.spocEmail = index.dom.main.find('#spocemail');
            index.dom.phone = index.dom.main.find('#phone');
            index.dom.pan = index.dom.main.find('#pan');
            index.dom.tan = index.dom.main.find('#tan');
            index.dom.validateOtp = index.dom.main.find('#validate_otp');
            index.dom.gstin = index.dom.main.find('#gstin');
            index.dom.spocFullname = index.dom.main.find('#spocfullname');
            index.dom.spocEmail1 = index.dom.main.find('#spocemail1');
            index.dom.jobSector = index.dom.main.find('#jobsector');
            index.dom.country = index.dom.main.find('#country');
            index.dom.addressLine1 = index.dom.main.find('#addressline1');
            index.dom.addressLine2 = index.dom.main.find('#addressline2');
            index.dom.state = index.dom.main.find('#state');
            index.dom.city = index.dom.main.find('#city');
            index.dom.zipCode = index.dom.main.find('#zipcode');
            index.dom.annualDemandForHiring = index.dom.main.find('#annualdemandforhiring');
            index.dom.logoFile = index.dom.main.find('#logofile');
            index.dom.certificateOfIncorporation = index.dom.main.find('#certificateofincorporation');
            index.dom.addressProof = index.dom.main.find('#addressproof');
            index.dom.typeOfBusiness = index.dom.main.find('#typeofbusiness');
            index.dom.typeOfIndustry = index.dom.main.find('#typeofindustry');
            index.dom.industryRegistrationForm = index.dom.main.find('#industryregistrationform');
            index.dom.btnSendOtp = index.dom.main.find('#btn-send-otp');
            index.dom.mobileUniversity = index.dom.main.find('.mobile-university');


            index.dom.main.on('keypress', '#firstname', function(e) {
                var k = e.which;
                var allow = k >= 65 && k <= 90 || // A-Z
                k >= 97 && k <= 122 || // A-z
                k == 32;
                if (!allow) {
                    e.preventDefault();
                }
            });
            index.dom.main.on('keypress', '#phone', function(e) {
                var k = e.which;
                var allow = k >= 48 && k <= 57; // 0-9

                if (!allow) {
                    e.preventDefault();
                }
            });
            // Select2  for sector
            index.dom.jobSector.select2({
                placeholder: index.langs.selectSector,
                allowClear: true,
                ajax: {
                    delay: 1000,
                    data: function(params) {
                        var query = {
                            search: params.term,
                            page: params.page || 1
                        };
                        // Query parameters will be ?search=[term]&page=[page]
                        return query;
                    },
                    transport: function(params, success, failure) {
                        var promises = ajax.call([{
                            args: params,
                            methodname: 'local_custom_auth_get_select2_sector'
                        }]);
                        promises[0].done(success).fail(failure);
                    },
                    // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                },
                dropdownParent: index.dom.jobSector.parent('div')

            });
            // Select2  for Country
            index.dom.country.select2({
                placeholder: index.langs.country,
                allowClear: true,
                ajax: {
                    delay: 1000,
                    data: function(params) {
                        var query = {
                            search: params.term,
                            page: params.page || 1
                        };
                        // Query parameters will be ?search=[term]&page=[page]
                        return query;
                    },
                    transport: function(params, success, failure) {
                        var promises = ajax.call([{
                            args: params,
                            methodname: 'local_custom_auth_get_select2_country'
                        }]);
                        promises[0].done(success).fail(failure);
                    },
                    // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                },
                dropdownParent: index.dom.country.parent('div')
            });
            index.action.initStateSelect2();
            index.action.initCitySelect2();
            index.dom.country.on('change', function() {
                 index.dom.state.html('');
                if (index.dom.country != null) {
                    index.dom.state.val(null).trigger('change');
                } else {
                    index.dom.state.val(null).trigger('change');
                }

            });
            index.dom.state.on('change', function() {
                index.dom.city.html('');
                if (index.dom.state != null) {
                    index.dom.city.val(null).trigger('change');
                } else {
                    index.dom.city.val(null).trigger('change');
                }
            });

            // index.dom.typeOfBusiness.on('change', function(e) {
            //     if (index.dom.typeOfBusiness != null) {
            //         index.fetchTypeOfIndustries(index.dom.typeOfBusiness.val());
            //     } else {
            //         index.dom.typeOfIndustry.html('<option value="" selected disabled>' + index.langs.selectTypeofIndustry + '</option>');
            //     }
            // });

            // Form Validation Part .
            index.dom.main.on('click', '#btn-save-changes', function(e) {
                index.action.resetValidationError(e);
                var checkvalidation = index.action.fieldValidationError(e);
                if (checkvalidation == false) {
                    return false;
                } else if (index.dom.validateOtp.val().trim() == '' || !$.isNumeric(index.dom.validateOtp.val().trim()) || index.dom.validateOtp.val().trim().length != 5) {
                    index.dom.otpValidateRequired.html(index.langs.otpValid).css({color: 'red'});
                    return false;
                } else if (index.dom.country.val() === null) {
                    index.dom.countryRequired.html(index.langs.country).css({color: 'red'});
                    return false;
                } else if (index.dom.state.val() === null) {
                    index.dom.stateRequired.html(index.langs.selectState).css({color: 'red'});
                    return false;
                } else if (index.dom.city.val() === null) {
                    index.dom.cityRequired.html(index.langs.selectCity).css({color: 'red'});
                    return false;
                } else if (index.dom.addressLine1.val().trim() == '') {
                    index.dom.addressLine1Required.html(index.langs.enterLane1).css({color: 'red'});
                    return false;
                } else if (index.dom.addressLine2.val().trim() == '') {
                    index.dom.addressLine2Required.html(index.langs.enterLane2).css({color: 'red'});
                    return false;
                } else if (index.dom.zipCode.val().trim() == '' || !$.isNumeric(index.dom.zipCode.val().trim())) {
                    index.dom.zipCodeRequired.html(index.langs.enterValidZipcode).css({color: 'red'});
                    return false;
                } else if (index.dom.jobSector.val() === null) {
                    index.dom.jobSectorRequired.html(index.langs.selectSector).css({color: 'red'});
                    return false;
                } else if (index.dom.pan.val().trim() == '') {
                    index.dom.panRequired.html(index.langs.enterValidPanNumber).css({color: 'red'});
                    return false;
                } else if (index.dom.tan.val().trim() == '') {
                    index.dom.tanRequired.html(index.langs.enterValidTanNumber).css({color: 'red'});
                    return false;
                } else if (index.dom.gstin.val().trim() == '') {
                    index.dom.gstinRequired.html(index.langs.enterValidGstnNumber).css({color: 'red'});
                    return false;
                } else if (index.dom.annualDemandForHiring.val().trim() == '' || !$.isNumeric(index.dom.annualDemandForHiring.val().trim())) {
                    index.dom.annualeDmandforhiringRequired.html(index.langs.enterAnnualDemandForHiring).css({color: 'red'});
                    return false;
                } else if (index.dom.logoFile[0].files.length == 0 || !index.variable.imageExtensions.includes(index.dom.logoFile[0].files[0].type)) {
                    index.dom.logoFileRequired.html(index.langs.uploadValidImage).css({color: 'red'});
                    return false;
                } else if (index.dom.certificateOfIncorporation[0].files.length == 0 || !index.variable.documentExtensions.includes(index.dom.certificateOfIncorporation[0].files[0].type)) {
                    index.dom.certificateOfIncorporationRequired.html(index.langs.uploadValidCertificate).css({color: 'red'});
                    return false;
                } else if (index.dom.addressProof[0].files.length == 0 || !index.variable.documentExtensions.includes(index.dom.addressProof[0].files[0].type)) {
                    index.dom.addressProofRequired.html(index.langs.uploadAddressProof).css({color: 'red'});
                    return false;
                } else if (!$("#industryModal #accepttc").is(':checked')) {
                    Swal.fire({
                        position: 'center',
                        title: index.langs.oops,
                        text: index.langs.pleaseAcceptTermAndCon,
                        imageUrl: './pix/error.png',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    return false;
                } else {
                    index.action.createIndustryAjax();
                }
            });

            // OTP Validation .
            index.dom.main.on('click', '#btn-send-otp', function(e) {
                e.preventDefault();
                var validationstate = index.action.fieldValidationError(e);
                if (validationstate == true) {
                    index.dom.btnSendOtp.html(index.langs.pleaseWait).attr('disabled', true);
                    commonReg.sendOtp(index.dom.phone.val().trim(), index.dom.spocEmail.val().trim(), index.dom.firstName.val().trim(), '', 'i', e, index.dom.spocEmail1.val());
                }
            });
        }
    };
    return {
        init: index.action.getString
    };
});